import { Sentiments } from "./Sentiments";

export default class SentimentFiltersViewModel {
    isActive: boolean = false;

    isStartingSentimentEnabled: boolean = false;
    startingSentiment: string[] = [Sentiments[0], Sentiments[8]];
    isMiddleSentimentEnabled: boolean = false;
    middleSentiment: string[] = [Sentiments[0], Sentiments[8]];
    isFinalSentimentEnabled: boolean = false;
    finalSentiment: string[] = [Sentiments[0], Sentiments[8]];

    isStartingMoodEnabled: boolean = false;
    startingMood: string[] = [Sentiments[0], Sentiments[8]];
    isMiddleMoodEnabled: boolean = false;
    middleMood: string[] = [Sentiments[0], Sentiments[8]];
    isFinalMoodEnabled: boolean = false;
    finalMood: string[] = [Sentiments[0], Sentiments[8]];
}

